angular.module('PasswordExpiryWarning', ['ivpusic.cookie', 'EICDataStream3.config'])
  .directive('passwordExpiryMessage',
    [
      function () {
        return {
          restrict: 'E',
          templateUrl: '/app/passwordExpiryWarning/passwordExpiryMessage.partial.html',
          bindToController: true,
          controller: 'PasswordExpiryMessageController',
          controllerAs: 'message',
          link: function () {

          }
        }
      }
    ])
  .controller('PasswordExpiryMessageController',
    [
      '$scope', 'ipCookie', 'AUTH_CONFIG',
      function ($scope, ipCookie, AUTH_CONFIG) {
        var message = this;

        message.enabled = false;
        message.changePasswordUrl = AUTH_CONFIG.changePasswordUrl;

        message.dismiss = function () {
          //// Close the messagebox and store the fact that this message
          //// has been dismissed
          message.enabled = false;
          ipCookie('hidepasswordexpirymessage', 'true', { expires: 1, domain: ".the-eic.com" });
        };

        $scope.daysTilPasswordExpiry = function () {
          var passwordExpiryCookie = ipCookie('passwordexpiresat');

          var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
          var expirydate = new Date(passwordExpiryCookie).setHours(0, 0, 0, 0);
          var today = new Date().setHours(0, 0, 0, 0);

          var days = Math.round(Math.abs((today - expirydate) / (oneDay)));

          return days;
        };

        var showPasswordExpiryMessage = function () {
          // find out if there is a message to display by inspecting the cookie.
          // GuardCondition: bail if there is no expiry cooky or if the hide message is set
          var passwordExpiryCookie = ipCookie('passwordexpiresat');
          var hidepasswordexpirymessageCookie = ipCookie('hidepasswordexpirymessage');
          if (!passwordExpiryCookie || hidepasswordexpirymessageCookie) return;

          message.enabled = true;

          var days = $scope.daysTilPasswordExpiry();

          switch (days) {
            case 0:
              // this case should never arise because
              // the password has already expired
              message.type = 'danger';
              message.days = "The next time you log in";
              // message.dismiss();
              break;

            case 1:
              message.type = 'danger';
              message.days = "tomorrow";
              break;

            case 2:
              message.type = 'warning';
              message.days = "the day after tomorrow";
              break;

            default:
              message.type = 'warning';
              message.days = "in " + days + " days";
              break;

          }

        };

        $scope.$watch("daysTilPasswordExpiry", showPasswordExpiryMessage)


        // $scope.$on('$viewContentLoaded',
        //   function() {
        //     // find out if there is a message to display by inspecting the cookie.
        //     // GuardCondition: bail if there is no expiry cooky or if the hide message is set
        //     var passwordExpiryCookie = ipCookie('passwordexpiresat');
        //     var hidepasswordexpirymessageCookie = ipCookie('hidepasswordexpirymessage');
        //     if (!passwordExpiryCookie || hidepasswordexpirymessageCookie) return;
        //
        //     message.enabled = true;
        //
        //     var days = daysTilPasswordExpiry();
        //
        //     switch (days) {
        //         case 0:
        //             // this case should never arise because
        //             // the password has already expired
        //             message.type = 'danger';
        //             message.days = "The next time you log in";
        //            // message.dismiss();
        //             break;
        //
        //         case 1:
        //             message.type = 'danger';
        //             message.days = "tomorrow";
        //             break;
        //
        //         case 2:
        //             message.type = 'warning';
        //             message.days = "the day after tomorrow";
        //             break;
        //
        //         default:
        //             message.type = 'warning';
        //             message.days = "in " + days + " days";
        //             break;
        //
        //     }
        //
        //   });
      }
    ]);

